import React from 'react'
import { AD, ADVERTISEMENT, MOVIE, WEISCHER } from '../constants/itemTypes';
import SliderBasicItemAd from './SliderBasicItemAd';
import SliderBasicItemMovie from './SliderBasicItemMovie';
import SliderBasicItemWeischer from './SliderBasicItemWeischer';
import SliderBasicItemAdvertisement from './SliderBasicItemAdvertisement';

const SliderBasicItemSwitch = ({
    id,
    type,
    index,
    isCurrentSlide,
    oddSlide,
    kenBurnsToggle,
    isJustOneItem,
    autoplaySpeed,
    sliderTitle,
    className,
    moviesData, 
    adsData, 
    advertisementsData,
    weischerAdsData,
    backgroundVisualsSettings,
    attributeStyling,
    sliderType,
    canParallax,
    hiddenAttributes,
    showAvailableIn,
    theme,
    isMobile,
    translation,
    isConnectedFast,
    isInViewport,
    eventOrigins,
    onClickSlideItem
}) => {
    if(MOVIE === type && moviesData.hasOwnProperty(id)) {
        const movieData = moviesData[id]
        const adData = false

        return <div key={index}>
            <SliderBasicItemMovie
                className={className}
                movieData={movieData}
                adData={adData}
                sliderTitle={sliderTitle}
                oddSlide={oddSlide}
                kenBurnsToggle={kenBurnsToggle}
                canParallax={canParallax}
                showAvailableIn={showAvailableIn}
                attributeStyling={attributeStyling}
                sliderType={sliderType}
                isJustOneItem={isJustOneItem}
                isMobile={isMobile}
                isCurrentSlide={isCurrentSlide}
                hiddenAttributes={hiddenAttributes}
                isConnectedFast={isConnectedFast}
                isInViewport={isInViewport}
                backgroundVisualsSettings={backgroundVisualsSettings}
                autoplaySpeed={autoplaySpeed}
                theme={theme}
                translation={translation}
                eventOrigins={eventOrigins}
                onClickSlideItem={onClickSlideItem}
            />
        </div>
    } else if(AD === type && adsData.hasOwnProperty(id) && adsData[id] && adsData[id].hasOwnProperty('movieRefID') && adsData[id].movieRefID && adsData[id].movieRefID !== '' && moviesData.hasOwnProperty(adsData[id].movieRefID)) { // Why!? adsData[id].movieRefID !== '' &&  adsData[id].movieRefID
        const adData = adsData[id]
        const movieData = moviesData[adData.movieRefID]
         
        return <div key={index}>
            <SliderBasicItemMovie
                className={className}
                isMobile={isMobile}
                movieData={movieData}
                showAvailableIn={showAvailableIn}
                adData={adData}
                sliderTitle={sliderTitle}
                hiddenAttributes={hiddenAttributes}
                sliderType={sliderType}
                oddSlide={oddSlide}
                kenBurnsToggle={kenBurnsToggle}
                canParallax={canParallax}
                isJustOneItem={isJustOneItem}
                isCurrentSlide={isCurrentSlide}
                isConnectedFast={isConnectedFast}
                isInViewport={isInViewport}
                attributeStyling={attributeStyling}
                backgroundVisualsSettings={backgroundVisualsSettings}
                autoplaySpeed={autoplaySpeed}
                theme={theme}
                translation={translation}
                eventOrigins={eventOrigins}
                onClickSlideItem={onClickSlideItem}
            />
        </div>
    } else if(AD === type && adsData.hasOwnProperty(id)) {
        const adData = adsData[id]
        
        return <div key={index}>
            <SliderBasicItemAd
                adData={adData}
                oddSlide={oddSlide}
                kenBurnsToggle={kenBurnsToggle}
                canParallax={canParallax}
                theme={theme}
                isJustOneItem={isJustOneItem}
                className={className}
                isMobile={isMobile}
                sliderTitle={sliderTitle}
                backgroundVisualsSettings={backgroundVisualsSettings}
                autoplaySpeed={autoplaySpeed}
                translation={translation}
            />
        </div>
    } else if(WEISCHER === type && weischerAdsData.hasOwnProperty(id)) {
        const weischerData = weischerAdsData[id] 

        return <SliderBasicItemWeischer
            index={index}
            weischerData={weischerData}
        />
    } else if(ADVERTISEMENT === type && advertisementsData.items.hasOwnProperty(id)) {
        return <SliderBasicItemAdvertisement
            index={index}
            data={advertisementsData.items[id]}
            currentSlideInViewport={isCurrentSlide && isInViewport}
            isMobile={false}
        />
    } else {
        return ''
    }
}

export default SliderBasicItemSwitch 
    